var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"aggregator-list"},[(!_vm.list.length)?_c('li',[_c('span',{staticClass:"tag is-danger"},[_vm._v("List is empty")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item){return _c('li',{key:item},[_c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-small",class:{ 'is-success': _vm.activeItemName == item },on:{"click":function($event){_vm.selectItem(item)}}},[_vm._v(_vm._s(item))])])])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/common/item-list.vue?vue&type=template&id=6aae6b3f&scoped=true
// module id = 14kc
// module chunks = 0